module.exports = __webpack_public_path__ + "static/bell-db14f176e48b4b85705c1231768925f8.png";